import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'relationshipPriority');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'relationship_priorities',
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqRelationshipPriority.js